import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-belastingplichtige',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-belastingplichtige.component.html',
  styleUrl: './tekst-belastingplichtige.component.scss',
})
export class TekstBelastingplichtigeComponent {}
